import Container from '@/components/Container';

import Highlight from './highlight';
import ListPodcasts from './list';
import { usePodcastStore } from './store/usePodcastStore';
import { useEffect } from 'react';
import PodcastSkeleton from './loading';
import GetInvolved from './get-involved';
import Pagination from '@/components/Pagination';

export default function Podcast() {
  const { onInit, loading, podcastsMeta, onChangePage } = usePodcastStore();

  useEffect(() => {
    onInit();
  }, [onInit]);

  if (loading) {
    return <PodcastSkeleton />;
  }

  return (
    <>
      <Container className="mt-sh-30">
        <div className="col-span-12">
          <Highlight />
          <ListPodcasts />
          <Pagination
            pageSize={podcastsMeta?.pagination.pageCount || 1}
            currentPage={podcastsMeta?.pagination.page || 1}
            onChangePage={onChangePage}
          />
        </div>

        <GetInvolved showSuggestionBox={false} />
      </Container>
    </>
  );
}
